import { BitkitIconButton, IconChevronLeft, rem } from '@bitrise/bitkit-v2';
import { Box, BoxProps } from '@chakra-ui/react/box';
import { Card } from '@chakra-ui/react/card';
import { Text } from '@chakra-ui/react/text';

type LoginCardProps = {
  title?: string;
  subtitle?: string;
  onBackButtonClick?: () => void;
  backButtonLabel?: string;
  variant?: 'default' | 'transparent';
};

const LoginCard = ({
  children,
  title,
  subtitle,
  onBackButtonClick,
  backButtonLabel,
  variant = 'default',
  ...rest
}: BoxProps & LoginCardProps) => (
  <Card.Root
    asChild
    elevation={false}
    {...(variant === 'transparent' && { borderWidth: 0 })}
    maxWidth={rem(420)}
    width="fill-available"
    backgroundColor={variant === 'transparent' ? 'color/white/10' : 'background/primary'}
    {...rest}
  >
    <Card.Body display="flex" flexDirection="column" gap="16">
      {title && (
        <Box display="flex" flexDirection="column" alignItems="center" gap="4" position="relative">
          {onBackButtonClick && (
            <BitkitIconButton
              variant="tertiary"
              icon={IconChevronLeft}
              onClick={onBackButtonClick}
              width="32"
              height="32"
              padding="8"
              position="absolute"
              left="-16px"
              top="-4px"
              label={backButtonLabel || 'Back'}
            />
          )}
          <Text textStyle="heading/h4">{title}</Text>
          {subtitle && (
            <Text textStyle="body/md/regular" color="text/secondary">
              {subtitle}
            </Text>
          )}
        </Box>
      )}
      {children}
    </Card.Body>
  </Card.Root>
);

export default LoginCard;
